import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg, okMsg } from '../constants/messages'
import type { ResultDownloadInfo } from '../interfaces/Result'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C204DeviceExportProps {
  execDeviceExport: (deviceId: string) => Promise<ResultDownloadInfo>
  loading: loadStatus
}
// C204 デバイスエクスポートAPI呼出
export const useC204DeviceExport = (): C204DeviceExportProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execDeviceExport = async (deviceId: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // ボディ作成
      const body = {}
      // const body = { target: { all: true } };

      const response = await axios.post(
        buildDeviceUrl(deviceId, '/export'),
        body,
        {
          headers: header,
          // responseType: "blob",
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        // console.log(
        //   `content-disposition: ${response.headers["content-disposition"]}`
        // );
        // // レスポンスヘッダからファイル名を取得
        // const contentDisposition = response.headers["content-disposition"];
        // if (contentDisposition) {
        //   const fileName = getFileName(contentDisposition);
        //   fileDownload(response.data, fileName);
        // }
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      if (response.status === apiStatus.NO_CONTENT) {
        setLoading(loadStatus.LOADED)
        return { success: false, message: okMsg.NO_EXPORT_DATA }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execDeviceExport, loading }
}
